// extracted by mini-css-extract-plugin
export default {"containerStyle":"MfaContainer__containerStyle___to5zT","alertStyle":"MfaContainer__alertStyle___zeo0t"};